export const CIVIL_STATUSES = {
  SINGLE: 'single',
  MARRIED_SOCIETY: 'married_society',
  MARRIED_NONSOCIETY: 'married_nonsociety',
  CIVIL_UNION_SOCIETY: 'civil_union_society',
  CIVIL_UNION_NONSOCIETY: 'civil_union_nonsociety',
};

export const CIVIL_STATUS_LABELS = {
  [CIVIL_STATUSES.SINGLE]: 'Soltero/Divorciado/Viudo',
  [CIVIL_STATUSES.MARRIED_SOCIETY]: 'Casado: Sociedad Conyugal',
  [CIVIL_STATUSES.MARRIED_NONSOCIETY]: 'Casado: Separación de Bienes',
  [CIVIL_STATUSES.CIVIL_UNION_SOCIETY]: 'AUC: Comunidad de Bienes',
  [CIVIL_STATUSES.CIVIL_UNION_NONSOCIETY]: 'AUC: Separación de Bienes',
};

export const REQUIRES_SPOUSE_DATA = [
  CIVIL_STATUSES.MARRIED_SOCIETY,
  CIVIL_STATUSES.CIVIL_UNION_SOCIETY,
];